module.exports = __webpack_public_path__ + "img/mainImg.7defaeb0.jpg";